/**
 * The editorial guardrails' two switches (DESIGN ED-191, ED-192), apart from their texts so the interface's initial bundle can
 * read them without the directive data (`guardrails.ts` re-exports them).
 */

/**
 * Offer the option in the cost dialog (rollback level 2, plan §5): false hides the checkbox and forces the option off for new
 * runs. A job that ran with it keeps its label.
 */
export const GUARDRAILS_OFFERED = true;

/**
 * The option's state when the cost dialog opens (DESIGN ED-192): on, from G1's pilot on the stratified set (219 passages, one
 * run per arm; `docs/reports/bench-v3/guardrails-pilot.md`), which met the plan's three conditions (meaning failures not above
 * the off arm's upper bound, the failed share's upper bound at or under 30%, no channel over its floor at Tier C). G2's pilot
 * (ED-195, `docs/reports/bench-v3/guardrails-g2-pilot.md`) met them again with the declined outcome, and no channel's declined
 * share is above the off arm's failed-share bound, so the default stands. Unticking it gives the baseline's requests.
 */
export const GUARDRAILS_DEFAULT = true;

/**
 * The meaning review under the guardrails (GR3, plan §4.4, DESIGN ED-196, ED-197): the distinction checks, the prose review of
 * each rewrite and its stated reason, and their texts. Off by default: its pilot (`docs/reports/bench-v3/guardrails-g3-pilot.md`)
 * kept the meaning failures down and no channel rose, but the editor left 177 of 225 passages as they are and half of the
 * passages it tried failed (upper bound 62.6%, over the plan's 30%), so the gate for a default was not met. With it off the
 * guardrails are 2.27.0's; a run, the pilot tool or a test may turn it on (`RunOptions.review`).
 */
export const GUARDRAILS_REVIEW_DEFAULT = false;

/** The most versions a request asks for under the guardrails: their strategies leave `recast` out (checked in the tests). */
export const GUARDRAILS_MAX_VERSIONS = 2;
